var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'ui-datatable-container': true, 'bootstrap': _vm.bootstrap}},[_c('ui-spinner',{attrs:{"show":!_vm.bootstrap && _vm.loading}}),_vm._v(" "),_c('table',{ref:"datatable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }